import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "We found 412 customers with over 50K followers in our first scan across our BigCommerce + Shopify stores. Four of them are now ambassadors. This paid for itself in a week.",
    name: "Nadia Chen",
    role: "Founder, Orbital Skin",
    stat: "+214% UGC volume",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200",
  },
  {
    quote:
      "We were paying agencies $8K/mo to scrape creator lists. InfluenceDetector surfaces better matches directly from people who already buy our stuff.",
    name: "Marcus Reyes",
    role: "Head of Growth, Hellhound Coffee",
    stat: "$96K saved annually",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200",
  },
  {
    quote:
      "Install took 90 seconds on WooCommerce. First match surfaced a creator with 610K followers on our second-largest customer order. Insane.",
    name: "Priya Shah",
    role: "CMO, Lumen Wear",
    stat: "610K reach unlocked · day one",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0B0B0D]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#D4FF00] font-semibold">
            Proof
          </p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl mt-4">
            Brands stopped <br />
            buying influencer <br />
            lists.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="group relative bg-[#09090B] border border-white/10 p-8 rounded-sm flex flex-col hover:border-[#D4FF00]/40 transition-all duration-300"
            >
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-[#D4FF00] text-[#D4FF00]" />
                ))}
              </div>
              <blockquote className="font-display uppercase text-xl md:text-2xl leading-tight flex-1">
                "{t.quote}"
              </blockquote>
              <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold truncate">{t.name}</div>
                  <div className="text-xs text-[#A1A1AA] truncate">{t.role}</div>
                </div>
                <div className="text-[10px] tracking-[0.14em] uppercase font-mono-id text-[#D4FF00] text-right max-w-[7rem]">
                  {t.stat}
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
